import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="ueber-mich" className="py-24 md:py-32 bg-secondary" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-accent mb-16 md:mb-24 text-center md:text-left" data-id="element-19">
          Architektur trifft Energieberatung
        </motion.h2>

        <div className="flex flex-col md:flex-row gap-16 lg:gap-24 items-center md:items-start" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full md:w-1/3 max-w-sm shrink-0" data-id="element-21">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden relative" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/ubv5iMfcH6PjtQRWmP5D7n/ChatGPT_Image_30._Mai_2026,_05_10_34.png" alt="Portrait von Josephine Henkel - Architektin und Energieeffizienz-Expertin für Bestandsgebäude und Sanierung in Berlin" className="w-full h-full object-cover" data-id="element-23" />
              <div className="absolute inset-0 bg-accent/5 mix-blend-multiply" data-id="element-24"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-sage rounded-2xl -z-10" data-id="element-25"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-2/3" data-id="element-26">
            <div className="space-y-6 text-accent/80 font-light text-lg leading-relaxed" data-id="element-27">
              <p data-id="element-28">
                Ich bin Architektin (M.Sc.), Ingenieurin und
                Energieeffizienz-Expertin mit besonderem Schwerpunkt auf
                Bestandsgebäuden und nachhaltiger Sanierung.
              </p>
              <p data-id="element-29">
                Bereits während meines Architekturstudiums habe ich mich auf das
                Bauen im Bestand sowie auf nachhaltige Bau- und
                Sanierungskonzepte spezialisiert. Sowohl meine Bachelor- als
                auch meine Masterarbeit haben sich intensiv mit diesen Themen
                beschäftigt.
              </p>
              <p data-id="element-30">
                Für mich steht der Mensch im Mittelpunkt: Energieeffizienz zeigt
                sich nicht nur in Kennzahlen, sondern auch im Wohnkomfort, im
                Wohlbefinden und im Gefühl, zuhause zu sein.
              </p>
              <p data-id="element-31">
                Ich bin überzeugt, dass die Modernisierung bestehender Gebäude
                häufig sinnvoller ist als Abriss und Neubau – sowohl aus
                ökologischer als auch aus kultureller Perspektive.
              </p>
              <p data-id="element-32">
                Mit meiner Kombination aus Architekturwissen,
                Energieeffizienz-Expertise und praktischer Planungserfahrung
                entwickle ich individuelle und langfristig sinnvolle Lösungen.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}